const TextPlaceholder = ({
  width,
}: {
  width?: string; // width in percentage. If not provided, will be 100%
}) => {
  return (
    <div
      className={`h-4 w-[${
        width ?? "100"
      }%] animate-pulse rounded-full bg-bg-subtle`}
    />
  );
};

export default TextPlaceholder;
